import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

function AuthForm({ mode }) {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", full_name: "", company: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      if (mode === "login") {
        await login(form.email, form.password);
      } else {
        await register(form.email, form.password, form.full_name, form.company);
      }
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  return (
    <div style={{
      minHeight: "100vh", background: "var(--bg)",
      display: "flex", alignItems: "center", justifyContent: "center", padding: 24
    }}>
      <div style={{ width: "100%", maxWidth: 400 }}>

        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{ fontFamily: "var(--mono)", fontSize: 18, fontWeight: 700, color: "var(--accent)", letterSpacing: "0.15em" }}>
            HIGH HORSE
          </div>
          <div style={{ fontSize: 11, color: "var(--subtext)", letterSpacing: "0.1em", marginTop: 4 }}>
            ENVIRONMENTAL INTEL
          </div>
        </div>

        {/* Card */}
        <div className="card" style={{ padding: 32 }}>
          <h2 style={{ fontWeight: 700, fontSize: 20, marginBottom: 6 }}>
            {mode === "login" ? "Welcome back" : "Create your account"}
          </h2>
          <p style={{ fontSize: 12, color: "var(--subtext)", marginBottom: 28 }}>
            {mode === "login"
              ? "Sign in to your High Horse account"
              : "Start with a free account. Upgrade anytime."}
          </p>

          <form onSubmit={handle}>
            {mode === "register" && (
              <>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ fontSize: 11, color: "var(--subtext)", fontFamily: "var(--mono)", display: "block", marginBottom: 6 }}>
                    FULL NAME
                  </label>
                  <input className="input" placeholder="Jane Smith" value={form.full_name} onChange={set("full_name")} />
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ fontSize: 11, color: "var(--subtext)", fontFamily: "var(--mono)", display: "block", marginBottom: 6 }}>
                    COMPANY
                  </label>
                  <input className="input" placeholder="Acme Corp (optional)" value={form.company} onChange={set("company")} />
                </div>
              </>
            )}

            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 11, color: "var(--subtext)", fontFamily: "var(--mono)", display: "block", marginBottom: 6 }}>
                EMAIL
              </label>
              <input className="input" type="email" placeholder="you@company.com" value={form.email} onChange={set("email")} required />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ fontSize: 11, color: "var(--subtext)", fontFamily: "var(--mono)", display: "block", marginBottom: 6 }}>
                PASSWORD
              </label>
              <input className="input" type="password" placeholder="••••••••" value={form.password} onChange={set("password")} required />
            </div>

            {error && (
              <div style={{
                padding: "10px 14px", borderRadius: 7, marginBottom: 16,
                background: "rgba(255,59,59,0.1)", border: "1px solid rgba(255,59,59,0.2)",
                fontSize: 12, color: "var(--danger)"
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              style={{ width: "100%", justifyContent: "center", padding: "11px 20px" }}
            >
              {loading ? "Please wait..." : mode === "login" ? "Sign in" : "Create account"}
            </button>
          </form>

          <div style={{ textAlign: "center", marginTop: 20, fontSize: 12, color: "var(--subtext)" }}>
            {mode === "login" ? (
              <>Don't have an account? <Link to="/register" style={{ color: "var(--accent)" }}>Sign up free</Link></>
            ) : (
              <>Already have an account? <Link to="/login" style={{ color: "var(--accent)" }}>Sign in</Link></>
            )}
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: 20, fontSize: 11, color: "var(--subtext)" }}>
          <Link to="/pricing" style={{ color: "var(--subtext)" }}>View pricing</Link>
          {" · "}
          <Link to="/" style={{ color: "var(--subtext)" }}>Back to dashboard</Link>
        </div>
      </div>
    </div>
  );
}

export function Login() { return <AuthForm mode="login" />; }
export function Register() { return <AuthForm mode="register" />; }
